/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const sepaPaymentMethodDetailsSchema = z.object({
	last4: z.string(),
	country: z.string(),
})

export type SepaPaymentMethodDetailsSchema = z.infer<typeof sepaPaymentMethodDetailsSchema>
